import { render, staticRenderFns } from "./FormBankStatement.vue?vue&type=template&id=68feb0d9"
import script from "./FormBankStatement.vue?vue&type=script&lang=js"
export * from "./FormBankStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports